import { Link } from 'react-router-dom'
import { PARCEIROS_ACCENT, PARCEIROS_CADASTRO_PATH } from './parceirosBrand'
import {
  PARCEIROS_AUDIENCIA,
  PARCEIROS_BENEFICIOS,
  PARCEIROS_GANHOS,
  PARCEIROS_POR_QUE,
  PARCEIROS_STEPS,
} from './parceirosPublicCopy'

function Cards({ items }: { items: ReadonlyArray<{ titulo: string; detalhe: string }> }) {
  return (
    <div className='grid gap-3 md:grid-cols-3'>
      {items.map((item) => (
        <article key={item.titulo} className='rounded-2xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-xl'>
          <p className='font-medium text-white'>{item.titulo}</p>
          <p className='mt-1 text-sm leading-6 text-white/60'>{item.detalhe}</p>
        </article>
      ))}
    </div>
  )
}

export function ParceirosPublicStory() {
  return (
    <div className='grid gap-10'>
      <section id='por-que' className='grid gap-4'>
        <h2 className='text-2xl font-black'>Por que indicar a Rocket?</h2>
        <Cards items={PARCEIROS_POR_QUE} />
      </section>

      <section id='ganhos' className='grid gap-4'>
        <div className='grid gap-2'>
          <h2 className='text-2xl font-black'>Quanto você pode ganhar</h2>
          <p className='max-w-2xl text-sm leading-6 text-white/60'>
            O modelo muda conforme o perfil. O percentual devido é o confirmado quando o portal é aprovado.
          </p>
        </div>
        <div className='grid gap-3 md:grid-cols-2'>
          {PARCEIROS_GANHOS.map((item) => (
            <article key={item.titulo} className='rounded-2xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-xl'>
              <p className='font-medium text-white'>{item.titulo}</p>
              <p className='mt-1 text-sm leading-6 text-white/60'>{item.detalhe}</p>
            </article>
          ))}
        </div>
      </section>

      <section className='grid gap-4'>
        <h2 className='text-2xl font-black'>O que fica com cada lado</h2>
        <Cards items={PARCEIROS_BENEFICIOS} />
      </section>

      <section id='como-funciona' className='grid gap-4'>
        <h2 className='text-2xl font-black'>Como funciona</h2>
        <ol className='grid gap-3 md:grid-cols-2'>
          {PARCEIROS_STEPS.map((item) => (
            <li
              key={item.step}
              className='grid grid-cols-[auto_1fr] items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-xl'
            >
              <span className='flex h-9 w-9 items-center justify-center rounded-full text-sm font-black text-white' style={{ background: PARCEIROS_ACCENT }}>
                {item.step}
              </span>
              <div className='grid gap-1'>
                <p className='font-medium text-white'>{item.title}</p>
                <p className='text-sm text-white/60'>{item.detail}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section id='quem-participa' className='grid gap-4'>
        <h2 className='text-2xl font-black'>Quem participa</h2>
        <div className='grid gap-3 sm:grid-cols-2 lg:grid-cols-4'>
          {PARCEIROS_AUDIENCIA.map((item) => (
            <article key={item.titulo} className='rounded-2xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-xl'>
              <p className='font-medium text-white'>{item.titulo}</p>
              <p className='mt-1 text-sm leading-6 text-white/60'>{item.detalhe}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  )
}

export function ParceirosPublicClose() {
  return (
    <section className='rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl'>
      <h2 className='max-w-xl text-2xl font-black leading-tight'>
        Tem uma loja para indicar? Transforme essa conexão em uma nova oportunidade de receita.
      </h2>
      <Link
        to={PARCEIROS_CADASTRO_PATH}
        className='mt-5 inline-flex rounded-full px-5 py-3 text-sm font-medium text-white active:scale-95'
        style={{ background: PARCEIROS_ACCENT }}
      >
        Quero me cadastrar grátis
      </Link>
    </section>
  )
}
